import { REFERENCE_RATE_BASIS_KEYS } from 'src/app/product-capture/model/consts/reference-rate-basis.const';
import { FCSelector } from '../../model/form-config.interface';
import {
  PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FIXED_RATE,
  PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FLOATING_REFERENCE_RATE,
  PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_RATE_BASIS,
} from './product-capture-field-selectors.consts';

export const STRIKE_ADJUSTMENT_RATE_BASIS: FCSelector = {
  formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_RATE_BASIS],
  options: [
    {
      id: REFERENCE_RATE_BASIS_KEYS.FIXED,
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FIXED_RATE,
          ],
          hidden: false,
          readOnly: false,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FLOATING_REFERENCE_RATE,
          ],
          selectValues: [null],
          hidden: true,
          readOnly: false,
        },
      ],
    },
    {
      id: REFERENCE_RATE_BASIS_KEYS.FLOATING,
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FIXED_RATE,
          ],
          selectValues: [null],
          hidden: true,
          readOnly: false,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FLOATING_REFERENCE_RATE,
          ],
          hidden: false,
          readOnly: false,
        },
      ],
    },
  ],
};
